<div class="container mat-elevation-z3 g-0">
    <p
            cdkDrag
            cdkDragHandle
            cdkDragRootElement=".cdk-overlay-pane"
            class="title"
    >
        {{ 'MODALS.HEADERS.ADD_MEMBER' | translate }}
    </p>

    <form [formGroup]="addUserForm">
        <mat-form-field style="width: 90%;">
            <mat-label>{{ 'BUTTON_TEXT.SEARCH' | translate }}</mat-label>
            <input formControlName="filter" matInput>
        </mat-form-field>
        <mat-form-field style="width: 90%; margin-bottom: 1vh; margin-top: 1vh;">
            <mat-select #emailList [value]="'another'">
                <mat-option [value]="'another'" selected>{{ 'MODALS.FIELDS.SELECT.INVITE' | translate }}</mat-option>
                <mat-option *ngFor="let member of membersFiltered"
                            [value]="member.email">{{ member.lastname }} {{ member.firstname }} <span
                        style="color: rgb(94, 94, 167);">{{ member.email }}</span></mat-option>
            </mat-select>
        </mat-form-field>
        <!--   <mat-slide-toggle *ngIf="emailUser.valid" formControlName="privateUser" style="margin-left: 1%; " color="secondary">
            <span  [style.font-weight]="privateUser.value? 'bold': 'unset'">{{'CONTRACTS.FIELDS.PRIVATE'|translate}} </span>
          </mat-slide-toggle> -->
        <mat-form-field *ngIf="emailList.value==='another'" style="width: 90%; margin-bottom: 2vh;">
            <input formControlName="emailUser" matInput placeholder="{{'CONTRACTS.FIELDS.EMAIL'|translate}}">
            <mat-error *ngIf="emailUser.invalid"
                       style="font-size: medium; margin-top: 1vh;"> {{ 'ALERTS.EMAIL_ERROR'|translate }}
            </mat-error>
        </mat-form-field>
        <div class="button-group">
            <button 
              [disabled] = ""
                (click)="addUser('signer')" [disabled]="addUserForm.invalid||isAddSignerBlocked"
                class="button-icon size-l primary-button">
                {{ 'MODALS.BUTTONS.ADD_SIGN' | translate }}
                <mat-icon>edit</mat-icon>
            </button>
            <button class="button-icon size-l secondary-button"
              (click)="addUser('observer')" [disabled]="addUserForm.invalid"
              >
              {{ 'MODALS.BUTTONS.ADD_OBSERVER' | translate }}
              <mat-icon > supervisor_account</mat-icon>
            </button>
        </div>
    </form>
</div>
